import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://public.readdy.ai/ai/img_res/b8ad71ff0fdd6039b2e0b6abda21bfba.jpg"
            alt="Distribution Operations"
            className="w-full h-full object-cover object-center"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/85 via-slate-900/75 to-slate-900/85"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center text-white w-full">
          <div className="inline-flex items-center gap-2 mb-8 px-5 py-2.5 bg-white/15 backdrop-blur-md border border-white/25 rounded-full">
            <i className="ri-shield-star-line text-lg"></i>
            <span className="text-sm font-semibold tracking-wide">Veteran-Owned Distribution Partner</span>
          </div>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-8 leading-tight tracking-tight">
            Defending Freedom First<br />Through Reliable Distribution
          </h1>
          <p className="text-lg md:text-xl text-slate-100 mb-12 max-w-3xl mx-auto leading-relaxed">
            Professional wholesale distribution supporting municipal, institutional, and commercial supply chains with accountability and operational excellence.
          </p>
          <div className="flex flex-col sm:flex-row gap-5 justify-center">
            <Link 
              to="/contact" 
              className="whitespace-nowrap inline-flex items-center justify-center px-10 py-4 bg-white text-slate-900 font-semibold rounded-lg hover:bg-slate-50 transition-all duration-300 hover:shadow-xl cursor-pointer text-base"
            >
              Partner With Us
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Who We Serve */}
      <section className="py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-20">
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-5 tracking-tight">Who We Serve</h2>
            <p className="text-base text-slate-600 max-w-2xl mx-auto leading-relaxed">
              DFF Distribution supports institutional buyers and supply chain partners across public and commercial sectors.
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white p-8 rounded-xl border border-slate-200 hover:border-slate-300 hover:shadow-xl transition-all duration-300 group">
              <div className="w-14 h-14 flex items-center justify-center bg-slate-900 text-white rounded-xl mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-government-line text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-slate-900 mb-3">Municipal & Township Procurement</h3>
              <p className="text-sm text-slate-600 leading-relaxed">
                Supporting city and township purchasing departments with reliable supply continuity and compliant fulfillment.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl border border-slate-200 hover:border-slate-300 hover:shadow-xl transition-all duration-300 group">
              <div className="w-14 h-14 flex items-center justify-center bg-slate-900 text-white rounded-xl mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-building-line text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-slate-900 mb-3">Government & Institutional Buyers</h3>
              <p className="text-sm text-slate-600 leading-relaxed">
                Serving public sector organizations with structured procurement processes and documentation requirements.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl border border-slate-200 hover:border-slate-300 hover:shadow-xl transition-all duration-300 group">
              <div className="w-14 h-14 flex items-center justify-center bg-slate-900 text-white rounded-xl mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-file-list-3-line text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-slate-900 mb-3">Commercial & Contract Supply Partners</h3>
              <p className="text-sm text-slate-600 leading-relaxed">
                Supporting ongoing commercial contracts with consistent inventory flow and logistics coordination.
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl border border-slate-200 hover:border-slate-300 hover:shadow-xl transition-all duration-300 group">
              <div className="w-14 h-14 flex items-center justify-center bg-slate-900 text-white rounded-xl mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-store-line text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold text-slate-900 mb-3">Manufacturers & Brand Owners</h3>
              <p className="text-sm text-slate-600 leading-relaxed">
                Partnering with manufacturers seeking reliable distribution channels for institutional markets.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* What We Do */}
      <section className="py-28 bg-gradient-to-br from-slate-50 to-slate-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 tracking-tight">What We Do</h2>
              <p className="text-base text-slate-600 mb-6 leading-relaxed">
                DFF Distribution operates as a supply chain partner within established wholesale networks. We maintain authorized purchasing relationships with manufacturers, national brands, and distributors to support institutional and contract buyers.
              </p>
              <p className="text-base text-slate-600 mb-6 leading-relaxed">
                Our role is to provide reliable, compliant access to products and materials that support critical operations—from municipal fleet maintenance to public infrastructure projects to commercial facility management.
              </p>
              <p className="text-base text-slate-600 leading-relaxed">
                We focus on continuity, scale, and operational discipline to ensure our partners can depend on consistent supply availability and professional fulfillment.
              </p>
            </div>
            <div className="relative h-96 lg:h-full min-h-[500px] rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20warehouse%20operations%20showing%20organized%20distribution%20center%20with%20inventory%20management%20systems%2C%20commercial%20logistics%20facility%20with%20structured%20shelving%20and%20material%20handling%20equipment%2C%20institutional%20supply%20chain%20operations%2C%20clean%20professional%20environment%2C%20neutral%20color%20palette&width=800&height=600&seq=dff-what-we-do-001&orientation=landscape"
                alt="Distribution Operations"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Our Role in the Supply Chain */}
      <section className="py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-20">
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-5 tracking-tight">Our Role in the Supply Chain</h2>
            <p className="text-base text-slate-600 max-w-2xl mx-auto leading-relaxed">
              DFF Distribution bridges manufacturers, authorized distributors, and institutional demand through structured wholesale relationships.
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-10">
            <div className="text-center group">
              <div className="w-20 h-20 flex items-center justify-center bg-slate-900 text-white rounded-2xl mx-auto mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                <i className="ri-links-line text-3xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-4">Connecting Supply & Demand</h3>
              <p className="text-sm text-slate-600 leading-relaxed">
                We maintain relationships with manufacturers and distributors while understanding the procurement needs of institutional buyers, creating efficient pathways between supply sources and end users.
              </p>
            </div>
            <div className="text-center group">
              <div className="w-20 h-20 flex items-center justify-center bg-slate-900 text-white rounded-2xl mx-auto mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                <i className="ri-shield-check-line text-3xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-4">Ensuring Compliant Fulfillment</h3>
              <p className="text-sm text-slate-600 leading-relaxed">
                Our operations prioritize documentation, traceability, and adherence to regulatory requirements, ensuring that every transaction meets institutional standards and brand guidelines.
              </p>
            </div>
            <div className="text-center group">
              <div className="w-20 h-20 flex items-center justify-center bg-slate-900 text-white rounded-2xl mx-auto mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                <i className="ri-time-line text-3xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-4">Maintaining Supply Continuity</h3>
              <p className="text-sm text-slate-600 leading-relaxed">
                Through strategic inventory management and logistics coordination, we support consistent product availability for ongoing contracts and recurring institutional needs.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Partners Trust DFF Distribution */}
      <section className="py-28 bg-slate-900 text-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-20">
            <h2 className="text-4xl md:text-5xl font-bold mb-5 tracking-tight">Why Partners Trust DFF Distribution</h2>
            <p className="text-lg text-slate-300 max-w-2xl mx-auto leading-relaxed">
              Our approach to wholesale distribution is built on operational discipline, compliance, and long-term partnership alignment.
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-slate-800/50 backdrop-blur-sm p-8 rounded-xl border border-slate-700 hover:border-slate-600 hover:bg-slate-800/70 transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-slate-700 rounded-xl mb-6">
                <i className="ri-verified-badge-line text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-3">Compliance-First Operations</h3>
              <p className="text-sm text-slate-300 leading-relaxed">
                Every transaction is documented and traceable. We maintain rigorous standards to meet institutional procurement requirements and regulatory expectations.
              </p>
            </div>
            <div className="bg-slate-800/50 backdrop-blur-sm p-8 rounded-xl border border-slate-700 hover:border-slate-600 hover:bg-slate-800/70 transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-slate-700 rounded-xl mb-6">
                <i className="ri-team-line text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-3">Authorized Wholesale Relationships</h3>
              <p className="text-sm text-slate-300 leading-relaxed">
                We operate through established agreements with manufacturers and authorized distributors, ensuring product authenticity and brand integrity.
              </p>
            </div>
            <div className="bg-slate-800/50 backdrop-blur-sm p-8 rounded-xl border border-slate-700 hover:border-slate-600 hover:bg-slate-800/70 transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-slate-700 rounded-xl mb-6">
                <i className="ri-refresh-line text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-3">Long-Term Supply Stability</h3>
              <p className="text-sm text-slate-300 leading-relaxed">
                Our focus is on sustainable partnerships, not transactional volume. We build relationships designed to support ongoing supply needs over years.
              </p>
            </div>
            <div className="bg-slate-800/50 backdrop-blur-sm p-8 rounded-xl border border-slate-700 hover:border-slate-600 hover:bg-slate-800/70 transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-slate-700 rounded-xl mb-6">
                <i className="ri-tools-line text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-3">Operational Discipline</h3>
              <p className="text-sm text-slate-300 leading-relaxed">
                Professional logistics practices, inventory management, and fulfillment processes ensure reliable execution and minimal disruption.
              </p>
            </div>
            <div className="bg-slate-800/50 backdrop-blur-sm p-8 rounded-xl border border-slate-700 hover:border-slate-600 hover:bg-slate-800/70 transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-slate-700 rounded-xl mb-6">
                <i className="ri-medal-line text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-3">Values-Driven Leadership</h3>
              <p className="text-sm text-slate-300 leading-relaxed">
                As a veteran-owned business, we bring principles of accountability, integrity, and mission focus to every partnership and transaction.
              </p>
            </div>
            <div className="bg-slate-800/50 backdrop-blur-sm p-8 rounded-xl border border-slate-700 hover:border-slate-600 hover:bg-slate-800/70 transition-all duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-slate-700 rounded-xl mb-6">
                <i className="ri-compass-3-line text-2xl"></i>
              </div>
              <h3 className="text-lg font-semibold mb-3">Selective Alignment</h3>
              <p className="text-sm text-slate-300 leading-relaxed">
                We choose partnerships carefully, prioritizing alignment in values, operational standards, and long-term objectives over short-term gains.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Industries Supported */}
      <section className="py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-20">
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-5 tracking-tight">Industries Supported</h2>
            <p className="text-base text-slate-600 max-w-2xl mx-auto leading-relaxed">
              DFF Distribution serves supply chains across multiple sectors, supporting critical operations and infrastructure maintenance.
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="group bg-white rounded-2xl overflow-hidden border border-slate-200 hover:shadow-2xl transition-all duration-300">
              <div className="relative w-full h-64 overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Modern%20commercial%20vehicle%20fleet%20parked%20in%20organized%20rows%20at%20professional%20maintenance%20depot%2C%20clean%20municipal%20fleet%20operations%20with%20service%20trucks%20and%20utility%20vehicles%2C%20institutional%20automotive%20facility%20with%20structured%20parking%20layout%2C%20professional%20industrial%20setting%20with%20organized%20equipment%2C%20warm%20neutral%20tones%20with%20soft%20lighting%20creating%20depth%20and%20professionalism&width=600&height=400&seq=dff-industry-automotive-new-003&orientation=landscape"
                  alt="Automotive & Fleet"
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-8">
                <h3 className="text-xl font-semibold text-slate-900 mb-4">Automotive & Fleet</h3>
                <p className="text-sm text-slate-600 leading-relaxed mb-6">
                  Supporting municipal fleets, service operations, and maintenance supply chains with reliable access to automotive parts, fluids, and equipment.
                </p>
                <Link 
                  to="/industries" 
                  className="whitespace-nowrap inline-flex items-center text-slate-900 font-semibold hover:text-slate-700 cursor-pointer group"
                >
                  Learn More <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
                </Link>
              </div>
            </div>
            <div className="group bg-white rounded-2xl overflow-hidden border border-slate-200 hover:shadow-2xl transition-all duration-300">
              <div className="relative w-full h-64 overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20infrastructure%20construction%20site%20with%20organized%20public%20works%20operations%2C%20modern%20utility%20maintenance%20equipment%20and%20machinery%20in%20action%2C%20municipal%20infrastructure%20development%20with%20structured%20workflow%2C%20institutional%20civil%20engineering%20project%20environment%2C%20clean%20professional%20composition%20with%20earth%20tones%20and%20industrial%20equipment%2C%20natural%20daylight%20highlighting%20operational%20excellence&width=600&height=400&seq=dff-industry-infrastructure-new-003&orientation=landscape"
                  alt="Outdoor & Infrastructure"
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-8">
                <h3 className="text-xl font-semibold text-slate-900 mb-4">Outdoor, Infrastructure & Public Works</h3>
                <p className="text-sm text-slate-600 leading-relaxed mb-6">
                  Providing materials and equipment for municipal services, utilities support, and infrastructure maintenance operations.
                </p>
                <Link 
                  to="/industries" 
                  className="whitespace-nowrap inline-flex items-center text-slate-900 font-semibold hover:text-slate-700 cursor-pointer group"
                >
                  Learn More <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
                </Link>
              </div>
            </div>
            <div className="group bg-white rounded-2xl overflow-hidden border border-slate-200 hover:shadow-2xl transition-all duration-300">
              <div className="relative w-full h-64 overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20commercial%20building%20facilities%20with%20modern%20maintenance%20operations%2C%20organized%20hardware%20and%20tools%20display%20in%20institutional%20facility%20management%20center%2C%20clean%20professional%20workspace%20with%20structured%20equipment%20storage%20and%20maintenance%20supplies%2C%20commercial%20property%20management%20environment%2C%20neutral%20professional%20color%20palette%20with%20warm%20lighting%20emphasizing%20organization%20and%20efficiency&width=600&height=400&seq=dff-industry-facilities-new-003&orientation=landscape"
                  alt="Home, Hardware & Facilities"
                  className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-8">
                <h3 className="text-xl font-semibold text-slate-900 mb-4">Home, Hardware & Facilities</h3>
                <p className="text-sm text-slate-600 leading-relaxed mb-6">
                  Supporting commercial maintenance, contract supply, and institutional facilities with hardware, tools, and maintenance materials.
                </p>
                <Link 
                  to="/industries" 
                  className="whitespace-nowrap inline-flex items-center text-slate-900 font-semibold hover:text-slate-700 cursor-pointer group"
                >
                  Learn More <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-28 bg-gradient-to-br from-slate-50 to-slate-100">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 tracking-tight">
            Let's Discuss Partnership Alignment
          </h2>
          <p className="text-base text-slate-600 mb-10 leading-relaxed max-w-2xl mx-auto">
            Whether you're a procurement professional seeking reliable supply partners or a manufacturer looking for institutional distribution channels, we invite you to explore how DFF Distribution can support your objectives.
          </p>
          <Link 
            to="/contact" 
            className="whitespace-nowrap inline-flex items-center justify-center px-10 py-4 bg-slate-900 text-white font-semibold rounded-lg hover:bg-slate-800 hover:shadow-xl transition-all duration-300 cursor-pointer text-base"
          >
            Initiate Partnership Discussion
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}